import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M6 7.1v1.8h12V7.1z" fill="currentColor" />
            <path d="M6 12.9h6v-1.8H6z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 12C1 3.25 2.375 2 12 2s11 1.25 11 10-1.375 10-11 10S1 20.75 1 12m1.8 0c0-2.172.088-3.734.328-4.889.233-1.125.577-1.7.973-2.06.417-.379 1.109-.72 2.424-.945C7.845 3.88 9.606 3.8 12 3.8s4.154.08 5.475.306c1.315.225 2.007.566 2.424.945.396.36.74.935.973 2.06.24 1.155.328 2.717.328 4.889s-.088 3.734-.328 4.889c-.233 1.125-.577 1.7-.973 2.06-.417.379-1.109.72-2.424.945-1.32.226-3.081.306-5.475.306s-4.154-.08-5.475-.306c-1.315-.225-2.007-.566-2.424-.945-.396-.36-.74-.936-.973-2.06C2.888 15.734 2.8 14.172 2.8 12"
                fill="currentColor"
            />
        </g>
    </svg>
));
CardLinesOutlinedSize24Glyph.displayName = 'CardLinesOutlinedSize24Glyph';
